const API_URL = (process.env.REACT_APP_API_URL || 'https://singlesystem.com.br:4937').replace(/\/$/, '');

const AUTH_STORAGE_KEY = 'portal_auth';

async function requestJson(url, body) {
  let response;
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*',
      },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error('Não foi possível conectar à API. Tente novamente.');
  }

  const text = await response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }

  if (!response.ok) {
    const message =
      (typeof data === 'string' && data) ||
      data?.message ||
      text ||
      'Não foi possível concluir a operação.';
    throw new Error(message);
  }

  return data;
}

/**
 * Cadastra usuário.
 * POST {API_URL}/api/usuarios/login
 * Body: { email, senha }
 */
export async function salvarUsuario({ email, senha }) {
  const url = `${API_URL}/api/usuarios/login`;
  return requestJson(url, { email, senha });
}

/**
 * Autentica usuário e retorna TokenDTO { email, token }.
 * POST {API_URL}/api/usuarios/login/autenticar
 * Body: { email, senha }
 */
export async function autenticarUsuario({ email, senha }) {
  const url = `${API_URL}/api/usuarios/login/autenticar`;
  return requestJson(url, { email, senha });
}

/**
 * Solicita recuperação de senha.
 * POST {API_URL}/api/usuarios/esqueci-senha
 * Body: { email }
 */
export async function esqueciSenha({ email }) {
  const url = `${API_URL}/api/usuarios/esqueci-senha`;
  return requestJson(url, { email });
}

/**
 * Redefine a senha com o token enviado por e-mail.
 * POST {API_URL}/api/usuarios/resetar-senha
 * Body: { token, novaSenha }
 */
export async function resetarSenha({ token, novaSenha }) {
  const url = `${API_URL}/api/usuarios/resetar-senha`;
  return requestJson(url, { token, novaSenha });
}

export function salvarSessao({ email, token }) {
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ email, token }));
}

export function obterSessao() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function limparSessao() {
  localStorage.removeItem(AUTH_STORAGE_KEY);
}
